import { GEOLOCATION_DATA } from '@mm/api-routes';
import Controller from './Controller';

export default class UserGeodataController extends Controller {
  static async getData() {
    return fetch(GEOLOCATION_DATA, { method: 'POST' });
  }
}
